const eBikesData = [
  {
    id: "eco-dash",
    name: "1.8 kWh EV-Battery",
    description:
      "The 1.8 kWh ATP Li-ion EV battery delivers ultimate performance for electric bikes and electric scooters. Its ultra-light design enables faster acceleration, while low self-discharge ensures reliable starts. Enjoy hassle-free, zero-maintenance operation, long charging cycles, and rapid recharge times. Top-tier safety is guaranteed with overcharge protection, and remote monitoring provides real-time battery insights. With a 60V nominal voltage and 30Ah nominal capacity, this lithium-ion battery offers exceptional energy density and a long lifespan of over 2000 cycles.",
    image: "/assets/img/others/inverter-gallery-1.jpg",
    productOverview: {
      image: "/assets/img/product-3/eco-dash.png",
      imageAlt: "Atom Power 1.8 kWh  e-bike battery",
      eyebrow: "E-Bike Battery",
      title: "1.8 kWh EV-Battery",
      price: "Rs.148,000.00",
      compareAtPrice: "Rs.158,000.00",
      discountText: "Save 6%",
      note: "Tax included. Shipping calculated at checkout.",
      actions: [
        { label: "ADD TO CART", variant: "outline" },
        { label: "BUY IT NOW", to: "/contact", variant: "solid" },
      ],
      specs: [
        { label: "Energy", value: "1.92 kWh" },
        { label: "Voltage", value: "64V" },
        { label: "Nominal Capacity", value: "30Ah" },
        { label: "Battery Type", value: "LiFePO" },
        { label: "Life Cycles", value: "2,000 Cycles" },
      ],
    },
    specifications: {
      "Main-Parameters": {
        "Nominal Voltage": "64V",
        "Nominal Capacity": "30Ah",
        "Working Voltage": "44 - 67V",
        "Battery Type": "LiFePO",
        "Life Cycles": "2,000 Cycles",
        "Energy Density": "211 Wh/kg",
      },
      "Operating Parameters": {
        "Standard Charge Current": "10 - 20A",
        "Peak Charge Current": "30A",
        "Standard Discharge Current": "50A",
        "Peak Discharge Current": "60A",
        "Charging Cut-off Voltage": "67V",
        "Discharging Cut-off Voltage": "44V",
      },
      "Temperature / Humidity Parameters": {
        "Charging Temperature": "-20°C ~ 50°C",
        "Discharging Temperature": "-30°C ~ 50°C",
        "Storage Temperature": "-40°C ~ 40°C",
      },
    },
    gallery: [
      "/assets/img/product-3/eco-dash1.png",
      "/assets/img/product-3/eco-dash2.png",
      "/assets/img/product-3/eco-dash3.png",
    ],
  },
  {
    id: "eco-cruise",
    name: "2.2 kWh EV-Battery",
    description:
      "The 2.2 kWh ATP Li-ion EV battery delivers ultimate performance for electric bikes and electric scooters. Its ultra-light design enables faster acceleration, while low self-discharge ensures reliable starts. Enjoy hassle-free, zero-maintenance operation, long charging cycles, and rapid recharge times. Top-tier safety is guaranteed with overcharge protection, and remote monitoring provides real-time battery insights. With a 72V nominal voltage and 32Ah nominal capacity, this lithium-ion battery offers exceptional energy density and a long lifespan of over 2000 cycles.",
    image: "/assets/img/others/inverter-gallery-2.jpg",
    productOverview: {
      image: "/assets/img/product-3/eco-cruise.png",
      imageAlt: "Atom Power 2.2 kWh  e-bike battery",
      eyebrow: "E-Bike Battery",
      title: "2.2 kWh EV-Battery",
      price: "Rs.148,000.00",
      compareAtPrice: "Rs.158,000.00",
      discountText: "Save 6%",
      note: "Tax included. Shipping calculated at checkout.",
      actions: [
        { label: "ADD TO CART", variant: "outline" },
        { label: "BUY IT NOW", to: "/contact", variant: "solid" },
      ],
      specs: [
        { label: "Energy", value: "2.20 kWh" },
        { label: "Voltage", value: "73.6V" },
        { label: "Nominal Capacity", value: "30Ah" },
        { label: "Battery Type", value: "LiFePO" },
        { label: "Life Cycles", value: "2,000 Cycles" },
      ],
    },
    specifications: {
      "Main-Parameters": {
        "Nominal Voltage": "73.6V",
        "Nominal Capacity": "30Ah",
        "Working Voltage": "54 - 83V",
        "Battery Type": "LiFePO",
        "Life Cycles": "2,000 Cycles",
        "Energy Density": "211 Wh/kg",
      },
      "Operating Parameters": {
        "Standard Charge Current": "10 - 20A",
        "Peak Charge Current": "30A",
        "Standard Discharge Current": "50A",
        "Peak Discharge Current": "60A",
        "Charging Cut-off Voltage": "83V",
        "Discharging Cut-off Voltage": "54V",
      },
      "Temperature / Humidity Parameters": {
        "Charging Temperature": "-20°C ~ 50°C",
        "Discharging Temperature": "-30°C ~ 50°C",
        "Storage Temperature": "-40°C ~ 40°C",
      },
    },
    gallery: [
      "/assets/img/product-3/eco-dash1.png",
      "/assets/img/product-3/eco-dash2.png",
      "/assets/img/product-3/eco-dash3.png",
    ],
  },
  {
    id: "eco-powerbolt",
    name: "7.2 kWh EV Battery",
    description:
      "The 7.2 kWh ATP Li-ion EV battery delivers ultimate performance for electric vehicles demanding high power and reliability. Built with advanced LiFePO4 (Lithium Iron Phosphate) chemistry, its design ensures stable power delivery and long-term durability. Enjoy hassle-free, zero-maintenance operation, superior thermal stability, and optimized charging cycles. Top-tier safety is guaranteed with overcharge and temperature protection systems. With a 73.6V nominal voltage, an energy capacity of 7.36 kWh, and an overall capacity rating of 7.4 kWh, this battery offers exceptional energy density and an extended lifespan of over 4,500 cycles.",
    image: "/assets/img/others/inverter-gallery-3.jpg",
    productOverview: {
      image: "/assets/img/product-3/eco-powerbolt.png",
      imageAlt: "Atom Power 7.2 kWh  e-bike battery",
      eyebrow: "E-Bike Battery",
      title: "7.2 kWh EV Battery",
      price: "Rs.148,000.00",
      compareAtPrice: "Rs.158,000.00",
      discountText: "Save 6%",
      note: "Tax included. Shipping calculated at checkout.",
      actions: [
        { label: "ADD TO CART", variant: "outline" },
        { label: "BUY IT NOW", to: "/contact", variant: "solid" },
      ],
      specs: [
        { label: "Energy", value: "7.36 kWh" },
        { label: "Voltage", value: "73.6V" },
        { label: "Nominal Capacity", value: "30Ah" },
        { label: "Battery Type", value: "LiFePO" },
        { label: "Life Cycles", value: "4,500 Cycles" },
      ],
    },
    specifications: {
      "Main-Parameters": {
        "Nominal Voltage": "73.6V",
        "Nominal Capacity": "30Ah",
        "Working Voltage": "54 - 83V",
        "Battery Type": "LiFePO",
        "Life Cycles": "4,500 Cycles",
        "Energy Density": "211 Wh/kg",
      },
      "Operating Parameters": {
        "Standard Charge Current": "10 - 20A",
        "Peak Charge Current": "30A",
        "Standard Discharge Current": "80A",
        "Peak Discharge Current": "90A",
        "Charging Cut-off Voltage": "83V",
        "Discharging Cut-off Voltage": "54V",
      },
      "Temperature / Humidity Parameters": {
        "Charging Temperature": "-20°C ~ 50°C",
        "Discharging Temperature": "-30°C ~ 50°C",
        "Storage Temperature": "-40°C ~ 40°C",
      },
    },
     gallery: [
      "/assets/img/product-3/eco-dash1.png",
      "/assets/img/product-3/eco-dash2.png",
      "/assets/img/product-3/eco-dash3.png",
    ],
  },
];

export default eBikesData;
